module.exports = __webpack_public_path__ + "img/pr-3.73b57399.png";